const Page = class {
  constructor(
    {
      content = [],
      pageable = { pageNumber: -1 },
      totalElements,
      totalPages,
      last = false,
      sort,
      first,
      numberOfElements,
      size,
      number,
      empty
    },
    { contentFactory }
  ) {
    this.content = Array.isArray(content)
      ? typeof contentFactory === 'function'
        ? content.map(e => contentFactory(e))
        : content
      : []
    this.pageable = pageable
    this.totalElements = totalElements
    this.totalPages = totalPages
    this.last = last
    this.sort = sort
    this.first = first
    this.numberOfElements = numberOfElements
    this.size = size
    this.number = number
    this.empty = empty
  }
}

export default null

export const ofPage = (params = {}, option = {}) => new Page(params, option)
